// extracted by mini-css-extract-plugin
export default {"page-title-container":"PageTitle_page-title-container__AeXgP","page-title":"PageTitle_page-title__e+wsD"};